'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024 from "./presto.-List-Account-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473 from "./presto.-Presto-Router$$anon$73.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$72() {
  this.blH = null;
  this.blz = null;
  this.blA = false;
  this.blI = null;
  this.blJ = false;
  this.blM = null;
  this.blF = null;
  this.blG = false;
  this.blB = null;
  this.blC = false;
  this.blD = null;
  this.blE = false;
  this.blK = false;
  this.blL = false;
  this.blH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.blM = "ListAccountUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$72 as $c_Lpresto_PrestoRouter$$anon$72 };
$p = $c_Lpresto_PrestoRouter$$anon$72.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$72;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$72() {
}
export { $h_Lpresto_PrestoRouter$$anon$72 as $h_Lpresto_PrestoRouter$$anon$72 };
$h_Lpresto_PrestoRouter$$anon$72.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.blH;
});
$p.M = (function() {
  if ((!this.blA)) {
    this.blz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blA = true;
  }
  return this.blz;
});
$p.O = (function() {
  if ((!this.blJ)) {
    this.blI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blJ = true;
  }
  return this.blI;
});
$p.E = (function() {
  return this.blM;
});
$p.t = (function() {
  if ((!this.blG)) {
    this.blF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.blG = true;
  }
  return this.blF;
});
$p.N = (function() {
  if ((!this.blC)) {
    this.blB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().add(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.blC = true;
  }
  return this.blB;
});
$p.Q = (function() {
  if ((!this.blE)) {
    this.blD = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473.$c_Lpresto_PrestoRouter$$anon$73();
    this.blE = true;
  }
  return this.blD;
});
$p.v = (function() {
  if ((!this.blL)) {
    this.blK = false;
    this.blL = true;
  }
  return this.blK;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee507) => ((p) => \u03b4scrutinee507.cFx(p)))($j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024.$m_Lpresto_ListAccountUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$72 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$72, "presto.PrestoRouter$$anon$72", ({
  OP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$72 as $d_Lpresto_PrestoRouter$$anon$72 };
//# sourceMappingURL=presto.-Presto-Router$$anon$72.js.map
